import { createContext, useContext, useState, useEffect } from 'react';

const AdminDataContext = createContext(null);

export function useAdminData() {
    const context = useContext(AdminDataContext);
    if (!context) {
        throw new Error('useAdminData must be used within AdminDataContextProvider');
    }
    return context;
}

export function AdminDataContextProvider({ children }) {
    const [services, setServicesState] = useState([]);
    const [categories, setCategoriesState] = useState([]);
    const [counties, setCountiesState] = useState([]); 

    useEffect(() => {
        try {
            const safeParse = (key) => {
                const raw = sessionStorage.getItem(key);
                return raw ? JSON.parse(raw) : [];
            };

            const savedServices = safeParse('admin_services') || [];
            const savedCategories = safeParse('admin_categories') || [];
            const savedCounties = safeParse('admin_counties') || []; 

            setServicesState(savedServices);
            setCategoriesState(savedCategories);
            setCountiesState(savedCounties); 
        } catch (error) {
            console.warn('Failed to restore admin data from sessionStorage:', error);
        }
    }, []);

    const setServices = (data) => {
        setServicesState(data);
        sessionStorage.setItem('admin_services', JSON.stringify(data));
    };

    const setCategories = (data) => {
        setCategoriesState(data);
        sessionStorage.setItem('admin_categories', JSON.stringify(data));
    };

    const setCounties = (data) => { 
        setCountiesState(data);
        sessionStorage.setItem('admin_counties', JSON.stringify(data));
    };

    const hasServices = services.length > 0;
    const hasCategories = categories.length > 0;
    const hasCounties = counties.length > 0; 

    const resetAdminData = () => {
        sessionStorage.removeItem('admin_services');
        sessionStorage.removeItem('admin_categories');
        sessionStorage.removeItem('admin_counties'); 
        setServices([]);
        setCategories([]);
        setCounties([]); 
    };

    return (
        <AdminDataContext.Provider
            value={{
                services,
                setServices,
                hasServices,

                categories,
                setCategories,
                hasCategories,

                counties,        
                setCounties,     
                hasCounties,     

                resetAdminData,
            }}
        >
            {children}
        </AdminDataContext.Provider>
    );
}

export default AdminDataContext;